import {createStore, withProps} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';

export enum ValidationSummaryType {
  Valid = 'valid',
  Invalid = 'invalid',
  AlreadyActive = 'active',
  Duplicated = 'duplicated',
  Payed = 'payed',
}

export interface Site {
  id: string;
  host: string;
  loading: boolean;
  url: string;
  type?: ValidationSummaryType;
}

export const additionalSitesStore = createStore(
  {name: 'add-sites'},
  withProps<{isLoading: boolean}>({
    isLoading: false,
  }),
  withEntities<Site>(),
);
